import React from 'react';

import AirIcon from '../../../../../common/icons/AirIcon';

export default translationsStore => ({
  width: '80px',
  align: 'center',
  title: translationsStore.translate('lead.table.column.battery'),
  dataIndex: 'battery',
  className: 'carBattery',
  sorter: (a, b) => a.car.battery - b.car.battery,
  render: (text, record) => {
    return (
      <div style={{ fontWeight: 'bold' }} className={record.batteryRed ? 'red' : record.batteryOrange ? 'orange' : 'green'}>
        <AirIcon type="battery-full" />
        <div>{record.car.battery}</div>
      </div>
    );
  }
});
